var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8471 25.6091L13.8005 19.5625L15.7923 17.5707L19.8471 21.6255L27.8855 13.5871L29.8773 15.5789L19.8471 25.6091ZM2.84546 22.7637C2.06296 22.7637 1.39309 22.4851 0.835854 21.9278C0.278618 21.3706 0 20.7007 0 19.9182V2.84546C0 2.06296 0.278618 1.39309 0.835854 0.835854C1.39309 0.278618 2.06296 0 2.84546 0H25.6091C26.3916 0 27.0615 0.278618 27.6187 0.835854C28.176 1.39309 28.4546 2.06296 28.4546 2.84546V9.03433L19.8826 17.6063L15.7923 13.5159L9.78127 19.527L13.018 22.7637H2.84546ZM14.2273 12.8046L25.6091 5.69092V2.84546L14.2273 9.95911L2.84546 2.84546V5.69092L14.2273 12.8046Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4bcc59f9068545c0e7e6a4340e729fd1.svg";
export { ForwardRef as ReactComponent };